<script>
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {useSecurityStore} from "@/stores/Security.js";
import {computed, onMounted, watch} from "vue";
import {useTemplateStore} from "@/stores/Edms/Template.js";
import axios from "axios";

export default {
    props: {
        type: String,
    },
    setup(props) {
        const {loading, total, filter,} = useSharedData();

        const {transformFilterValues} = useSharedMethod();

        const {$router, $i18n} = useTools();

        const templateStore = useTemplateStore();
        const securityStore = useSecurityStore();

        filter.value = {archive: false}

        const headers = [
            {
                text: "...",
                sortable: false,
                align: "left",
                value: "action",
                width: "0%",
            },
            {
                text: $i18n.t("common.label"),
                align: "left",
                value: "name",
                sortable: true,
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_DOCUMENT_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.edit`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_DOCUMENT_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.delete`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.archive"),
                icon: 'mdi-archive',
                color: 'purple',
                access: (item) => !item.archive && securityStore.authorities['UPDATE_DOCUMENT_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.archive`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.unarchive"),
                icon: 'mdi-archive',
                color: 'purple',
                access: (item) => item.archive && securityStore.authorities['UPDATE_DOCUMENT_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.unarchive`, params: {id: item.id}})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            filter.value.type = props.type;
            axios.get('/templates', {params: transformFilterValues(filter.value)}).then((response) => {
                templateStore.setTemplates(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }


        const rootPath = computed(() => {
            if (props.type === 'HEADER') {
                return 'header_templates';
            } else if (props.type === 'FOOTER') {
                return 'footer_templates';
            }
            return 'templates';
        });

        function view(item) {
            $router.push({name: `${rootPath.value}.view`, params: {id: item.id}});
        }

        watch(() => filter.value, () => {
            findAll();
        }, {deep: true, immediate: true});

        onMounted(() => {
            findAll();
        });

        return {
            rootPath,
            templateStore,
            securityStore,
            headers,
            actions,
            loading,
            total,
            filter,
            findAll,
            view,
        };
    },
}
</script>

<template>
    <div>
        <w-app
            :title="$t('module.template')"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_DOCUMENT_PARAM']"
                    @press="$router.push({name: `${rootPath}.add`})"
                />
            </template>

            <template v-slot:content>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :items="templateStore.templates"
                    :total="total"
                    :loading="loading"
                    sort-by="name"
                    @rowDbClick="view"
                >
                    <template v-slot:item.name="{ item }">
                        <w-inline-text bold :text="item.name"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>